<template>
  <div class="c-edit-visit" @click="close">
    <n-loader :loading="$var('load')" />
    <div class="form" @click.stop>
      <div class="title main">Редактирование перерыва</div>

      <div v-if="!createCloseBreak" class="time-selector-wrapper">
        <div class="title">
          Время открытия:
        </div>
        <div class="time-selector">
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('hourIn')"
            @input="onTimeInput('hourIn', 23)"
            @blur="onBlurPad('hourIn')"
          />
          :
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('minuteIn')"
            @input="onTimeInput('minuteIn', 59)"
            @blur="onBlurPad('minuteIn')"
          />
        </div>
      </div>
      <div v-if="visit.child?.[0]" class="time-selector-wrapper">
        <div class="title">
          Время закрытия:
        </div>
        <div class="time-selector">
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('hourOut')"
            @input="onTimeInput('hourOut', 23)"
            @blur="onBlurPad('hourOut')"
          />
          :
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('minuteOut')"
            @input="onTimeInput('minuteOut', 59)"
            @blur="onBlurPad('minuteOut')"
          />
        </div>
      </div>
      <div v-if="!visit.child?.[0]" class="time-selector-wrapper">
        <div v-if="!createCloseBreak" class="close-break">
          <n-button class="add-button" @click="createCloseBreak = true">Закрыть перерыв</n-button>
        </div>
        <div v-if="createCloseBreak" class="create-close-break">
          <div class="wrapper center">
            <c-date-picker :pre-date="[closeDate]" :date.sync="closeDate" />
          </div>
          <div class="wrapper">
            <div class="title">
              Время закрытия:
            </div>
            <div class="time-selector">
              <n-input
                :placeholder="'00'"
                type="text"
                class="new-time-input"
                :maxlength="2"
                v-bind="$form.input('hourOut')"
                @input="onTimeInput('hourOut', 23)"
                @blur="onBlurPad('hourOut')"
              />
              :
              <n-input
                :placeholder="'00'"
                type="text"
                class="new-time-input"
                :maxlength="2"
                v-bind="$form.input('minuteOut')"
                @input="onTimeInput('minuteOut', 59)"
                @blur="onBlurPad('minuteOut')"
              />
            </div>
          </div>
          <div class="wrapper center ">
            <div class="close-break">
              <n-button class="add-button" @click="createCloseBreak = false">Отмена</n-button>
            </div>
            <div class="close-break">
              <n-button class="add-button" @click="createBreak">Создать</n-button>
            </div>
          </div>
        </div>
      </div>
      <n-input v-if="!createCloseBreak" v-bind="$form.input('editComment')" title="Комментарий (Не обязательно)" /><br>
      <div v-if="!createCloseBreak" class="buttons">
        <n-button class="cancel" @click="close">Отмена</n-button>
        <n-button @click="add">Сохранить</n-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CAddVisit',
  props: {
    visit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hours: [],
      minutes: [],
      createCloseBreak: false,
      closeDate: new Date(this.visit.createdAt),
    }
  },
  created() {
    this.$form.init({
      hourIn: {},
      minuteIn: {},
      hourOut: {},
      minuteOut: {},
      editComment: '',
    })
    this.generateHours()
    this.findTime()
  },
  methods: {
    onTimeInput(field, max) {
      let value = this.$form.get(field)

      value = value.replace(/\D/g, '')

      if (value.length > 2) {
        value = value.slice(0, 2)
      }

      const num = parseInt(value || '0')

      if (num > max) {
        value = max.toString().padStart(2, '0')
      }

      this.$form.set(field, value)
    },
    onBlurPad(field) {
      const val = this.$form.get(field)
      if (val !== undefined && val !== null && val.length === 1) {
        const padded = val.padStart(2, '0')
        this.$form.set(field, padded)
      }
    },
    findTime() {
      const hour = $app.date.format(this.visit.createdAt, 'hours')
      const minute = $app.date.format(this.visit.createdAt, 'minutes')
      this.$form.set('hourIn', (hour))
      this.$form.set('minuteIn', (minute))

      if (this.visit.child?.[0]) {
        const hour = $app.date.format(this.visit.child[0].createdAt, 'hours')
        const minute = $app.date.format(this.visit.child[0].createdAt, 'minutes')
        this.$form.set('hourOut', (hour))
        this.$form.set('minuteOut', (minute))
      }
    },
    close() {
      this.$emit('update:show', false)
    },
    generateHours() {
      this.hours = Array.from({ length: 24, }, (_, i) => ({
        value: i > 9?i:'0'+(i),
        title: i > 9?i:'0'+(i),
      }))
      this.minutes = Array.from({ length: 60, }, (_, i) => ({
        value: i > 9?i:'0'+(i),
        title: i > 9?i:'0'+(i),
      }))
    },
    add() {
      this.$var('load', true)
      const data = {
        ...this.$form.get(),
        hourIn: this.$form.get('hourIn'),
        minuteIn: this.$form.get('minuteIn'),
        hourOut: this.$form.get('hourOut'),
        minuteOut: this.$form.get('minuteOut'),
      }
      $api.breaks.edit($app.auth.user().companyId, this.visit.id, data).then(() => {
        this.close()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    createBreak() {
      this.$var('load', true)

      const data = {
        hours: this.$form.get('hourOut') +'',
        minutes: this.$form.get('minuteOut') + '',
        date: this.closeDate,
        type: this.visit.type,
        userId: this.visit.userId,
        status: 'end',
      }
      $api.breaks.create(this.visit.companyId, this.visit.userId, data).then(() => {
        this.close()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-edit-visit {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: #00000080;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;


  .close-break {
    .add-button {
      width: auto;
      display: flex;
      align-items: center;
      justify-content: right;
      margin-bottom: 0;
      margin-right: 15px;
    }
    :deep() {
      .n-button {
        background-color: var(--primary);
        color: #FFFFFF;
        border: none;
        border-radius: 12px;
        height: 48px;
        padding: 0 24px;
      }
    }
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .n-button {
      background-color: var(--primary);
      color: #FFFFFF;
      border: none;
      border-radius: 12px;
      height: 48px;
      padding: 0 24px;

      &.cancel {
        background-color: #ffffff;
        color: var(--primary);
        font-weight: 700;
        border: 1px solid var(--primary);
      }
    }
  }
  .buttons {
    width: 100%;
  }
  .form {
    padding: 15px;
    z-index: 1001;
    min-width: 400px;
    min-height: 200px;
    border-radius: 16px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: stretch;
    .title {
      font-size: 16px;
      color: #000000;
      font-weight: 500;
      &.main {
        margin-bottom: 15px;
      }
    }
    .time-selector-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .title {
        margin-right: 15px;
        font-weight: normal;
        font-size: 14px;
        color: #000000;
      }
    }

    .new-time-input {
      width: 50px;
      border-radius: 12px;
      text-align: center;
      box-shadow: 0 0 0 1px #e0e3f0;
      margin: 0 2px;

      ::v-deep {
        .n-input {
          border: none !important;
        }

        .n-content {
          width: 50px;
          height: 40px;
          padding: 6px 10px 6px 15px;
        }
      }
    }

    .time-selector {
      display: flex;
      align-items: center;
      justify-content: start;
      ::v-deep {

        .n-select {
          .v-select {
            padding: 2px;
          }
          .n-icon {
            display: none;
          }
          .n-text {
            text-align: center;
          }
          &:first-child {
            margin-right: 5px;
          }
          &:last-child {
            margin-left: 5px;
          }
          width: 60px;
          .n-content {
            padding: 0;
          }
          .n-icon {
            margin: 0 !important;
          }
          .n-popup-content {
            width: 60px;
            .n-dropdown-item {
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .n-item {
              text-align: center;
            }
          }
          .n-wrapper {
            padding: 0 5px;
            width: 60px;
          }
          .n-dropdown {
            width: 60px;
          }
        }
      }
    }
  }


  .create-close-break {
    width: 100%;
  }
  .wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    &.center {
      justify-content: center;
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
}
</style>
